import instance from "./instance";

export const imageFolderRequest = {
  getFolderList: async (token) => {
    const res = await instance.get("folder/list", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  },
  createFolder: async (token, data) => {
    const res = await instance.post("folder/create", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  },
  deleteFolder: async (token, data) => {
    const res = await instance.delete("folder/delete", {
      data: {
        folder_id: data.folder_id,
        lang: data.lang,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  },
  editFolder: async (token, data) => {
    const res = await instance.put("folder/update", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  },

  getImageListFromFolder: async (token, data) => {
    const res = await instance.post(`/attachment/list`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  },
};
